export const PROJECT_NAME = 'Techify react starter project';
export const TAG_LINE = 'Speed up your work';
export const POINT_MAX_RANGE_LIMIT = 95000000;

const constants = {
  PROJECT_NAME,
  TAG_LINE,
  POINT_MAX_RANGE_LIMIT
};

export default constants; 